import { GO_TO_VISIT_CALL_WITH_ID } from '../routes/paths';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export let vc = undefined;

const openVC = (ptName: string, visitId: string): void => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (vc && !vc.closed) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (vc.location.href.indexOf(visitId) !== -1) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            vc.focus();
            return;
        }
    }

    try {
        const width = 850,
            height = 550,
            left = (window.innerWidth - width) / 2,
            top = (window.innerHeight - height) / 2;

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        vc = window.open(
            GO_TO_VISIT_CALL_WITH_ID(visitId),
            'Eka care - Video call',
            'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + '',
        );
    } catch (e) {
        console.error(e);
    }
};

export default openVC;
